// This file is auto-generated don't edit it!
import { Component } from '@angular/core';

@Component({
    selector: 'ui-button-group-docs',
    templateUrl: './button-group.docs.generated.html',
})
export class UIButtonGroupDocs { }
